import * as React from 'react'
import { FC } from 'react'

import { Dialog, DialogBody } from '@sales-center/components'
import { ReOpenLeadFormNew, SalesTeamUser } from './ReOpenLeadFormNew'
import { Formik } from 'formik'
import { useData } from '@user/components/Leads/ReOpenDialog/hooks/useData'
import { useActions } from '@user/components/Leads/ReOpenDialog/hooks/useActions'

export interface ReOpenLeadDialogProps {
  handleSubmit: (stageId: number, owner?: string | null) => void
  salesFunnelId: number
  salesFunnelStageId: number
  onClose: () => void
  open: boolean
  salesTeamId: string
  assigneeId: string | null
}

export interface IReOpenFormModel {
  salesFunnelStageId: number
  owner: SalesTeamUser | null
  expectedClosingDate: Date | null
}

export const ReOpenLeadDialog: FC<ReOpenLeadDialogProps> = (props) => {
  const { handleSubmit, onClose, open, salesTeamId } = props

  const { initialValues, salesFunnelStages, owners } = useData(props)
  const { validate } = useActions()

  return (
    <Dialog
      onClose={onClose}
      open={open}
      title={`Re-Open Lead`}
      width="xs"
      titleStyle={{
        padding: '24px',
        paddingBottom: 2,
      }}
      hideClose={true}
    >
      <DialogBody>
        <Formik
          initialValues={initialValues}
          onSubmit={(values: IReOpenFormModel) => {
            handleSubmit(values.salesFunnelStageId, values.owner?.id || null)
          }}
          validate={validate}
        >
          <ReOpenLeadFormNew
            onClose={onClose}
            salesTeamId={salesTeamId}
            salesFunnelStages={salesFunnelStages}
            owners={owners}
          />
        </Formik>
      </DialogBody>
    </Dialog>
  )
}

ReOpenLeadDialog.displayName = 'ReOpenLeadDialog'
